import { AnyPrivileges } from '../shared/privilege-guard';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';
import { KycVideoPlayerComponent } from '../../app/shared/kyc-video-player/kyc-video-player.component';
import { PrdSignupResubmitComponent } from './prd-signup-resubmit/prd-signup-resubmit.component';
import { SignupSingleViewComponent } from './prd-signup-resubmit/signup-single-view/signup-single-view.component';
import { PortalUsersComponent } from './portal-users/portal-users.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { UserManagementComponent } from './role-management/user-management/user-management.component';
import { ListRolesVsPrevComponent } from './role-management/list-roles-vs-prev/list-roles-vs-prev.component';
import { UserModalComponent } from './role-management/user-management/admin-users/users/user-modal/user-modal.component';
import { UserReportComponent } from './role-management/user-report/user-report.component';
// import { ProductSignupComponent } from 'app/portal/products/product-signup/product-signup.component';
export const superAdminRoutes = [
  {
    path: 'super-admin',
    component: SuperAdminDashboardComponent,
    canActivate: [AnyPrivileges],
    data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS', 'REVIEW_PRODUCT_SIGNUP', 'MONITOR_PRODUCT_SIGNUPS'] },
    children: [
      {
        path: 'video-player',
        component: KycVideoPlayerComponent,
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP'] },
      },

      {
        path: 'manage-prd-signup',
        component: PrdSignupResubmitComponent,
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP', 'MONITOR_PRODUCT_SIGNUPS'] },
      },
      {
        path: 'signup-view/:id/:uid/:tab',
        component: SignupSingleViewComponent,
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP', 'MONITOR_PRODUCT_SIGNUPS', 'TRACK_SIGNUP_DETAILS'] },
      },
      {
        path: 'portal-users',
        component: PortalUsersComponent,
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS'] },
      },
      {
        path: 'user-management',
        component: RoleManagementComponent,
        canActivate: [AnyPrivileges],
        data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS'] },
        children: [
          {
            path: 'manage-users',
            component: UserManagementComponent,
            canActivate: [AnyPrivileges],
            data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS'] },
          },
          {
            path: 'previleges-list',
            component: ListRolesVsPrevComponent,
            canActivate: [AnyPrivileges],
            data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS'] },
          },
          { path: 'manage-user', component: UserModalComponent },
          {
            path: 'user-role-report',
            component: UserReportComponent,
            canActivate: [AnyPrivileges],
            data: { privileges: ['ADMIN_OPTIONS', 'MANAGE_ADMIN_USERS'] },
          },
        ],
      },

      // {
      //   path: 'products/:productId/signup/:userId',
      //   component: ProductSignupComponent,
      //   canActivate: [AnyPrivileges],
      //   data: { privileges: ['ADMIN_OPTIONS', 'REVIEW_PRODUCT_SIGNUP', 'MONITOR_PRODUCT_SIGNUPS'] },
      // },
    ],
  },
];
